import axios from './axios';

function getSubscriptionsCounters() {
  const url = `/gw/cargos-subscriptions-counters-v2/web/cargos/subscriptions/counters`;

  return axios.get(url);
}

export { getSubscriptionsCounters };
